var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Send } from '@mui/icons-material';
import { DynamicFormBuilderContainer } from '../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { useAppDispatch } from '../../../../store/hooks';
import { crmCommunicationTemplateList, CRMKeys, sendCommunication } from '../services/apiCalls';
export default function CommunicationTemplateForm(props) {
    var _this = this;
    var onClose = props.onClose, request = props.request;
    var ChannelType = request.ChannelType;
    var dispatch = useAppDispatch();
    var communicationFormData = [{
            type: FormItemTypes.Typography,
            name: 'Heading',
            columnSize: 12,
            fontSize: 'xl',
            fontWeight: 'strong',
            valueGetter: function (state) {
                switch (state === null || state === void 0 ? void 0 : state.ChannelType) {
                    case 'Notes':
                        return 'Add notes';
                    case 'Call':
                        return 'Call customer';
                    default:
                        return "Select ".concat(state === null || state === void 0 ? void 0 : state.ChannelType, " Template");
                }
            }
        }, ChannelType === 'Call' || ChannelType === 'Notes' ? null : {
            type: FormItemTypes.SearchSelect,
            name: 'Template',
            label: 'Select template',
            valueExpr: 'Name',
            getListData: crmCommunicationTemplateList,
            apiKey: CRMKeys.communicationTemplateList,
            columnSize: 6,
            setFormState: function (state, currValue) { return ({
                MessageText: currValue === null || currValue === void 0 ? void 0 : currValue.TemplateBody
            }); }
        }, ChannelType === 'Email' ? {
            type: FormItemTypes.TextInput,
            name: 'Value',
            label: 'Email',
            columnSize: 12,
            placeholder: 'Enter email address',
            setFieldProps: function (state) {
                return {
                    type: FormItemTypes.TextInput,
                    containerProps: {
                        display: (state === null || state === void 0 ? void 0 : state.Template) === 'Appointment Link' ? 'block' : 'none'
                    }
                };
            }
        } : ChannelType === 'Call' ? {
            type: FormItemTypes.NumberInput,
            name: 'Value',
            label: 'Mobile No.',
            columnSize: 12,
            placeholder: 'Enter 10 digit mobile number',
            InputProps: {
                startAdornment: '+91'
            },
            validator: function (value, state) {
                if ((state === null || state === void 0 ? void 0 : state.ChannelType) === 'Call' && (value === null || value === void 0 ? void 0 : value.length) !== 10) {
                    return 'Enter a valid 10 digit mobile number';
                }
                return '';
            }
        } : null, ChannelType === 'Call' ? null : {
            type: FormItemTypes.TextInput,
            name: 'MessageText',
            label: 'Message',
            columnSize: 12,
            multiline: true,
            minRows: 3,
            placeholder: 'Template body',
            maxLength: 300,
            InputProps: {
                readOnly: ChannelType !== 'Notes'
            }
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'Actions',
            columnSize: 12,
            spacing: 0,
            justifyContent: 'flex-end',
            columnGap: 1,
            elements: [{
                    type: FormItemTypes.Button,
                    name: 'cancel',
                    columnSize: 0,
                    children: 'Cancel',
                    variant: 'outlined',
                    size: 'small',
                    color: 'secondary',
                    onClick: function () {
                        onClose('cancel');
                    }
                }, {
                    type: FormItemTypes.Button,
                    name: 'submit',
                    columnSize: 0,
                    children: ChannelType === 'Call' ? 'Initiate call' : 'Send',
                    endIcon: /*#__PURE__*/ React.createElement(Send, {
                        color: "inherit"
                    }),
                    variant: 'contained',
                    size: 'small',
                    fullWidth: true,
                    onClick: function (e, request, api) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            // if (request?.ChannelType === 'Email' && request?.Template === 'Appointment Link') {
                            //     const emailRes = await sendEmail({ request });
                            //     if (emailRes?.success) {
                            //         dispatch(showSuccess('Email sent successfully!'))
                            //         request.ResponseStatus = 'Sent'
                            //     }
                            //     else {
                            //         dispatch(showError('Failed to send email'))
                            //         return;
                            //     }
                            // }
                            // if (request?.ChannelType === 'Call') {
                            //     if (request?.Value?.length !== 10) return 'submit'
                            //     const callRes = await crmCustomerCall({ request: { MobileNumber: request?.Value }, state: request })
                            //     if (callRes?.success) request.MessageText = 'Call initiated'
                            //     else request.MessageText = 'Failed to initiate call'
                            // }
                            // const res = await crmCreateComHistory({ request })
                            // if (res?.success) return 'submit'
                            return [2 /*return*/, 'submit'];
                        });
                    }); }
                }]
        }];
    return /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        mode: "edit",
        formData: communicationFormData,
        getFormAPI: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, ({
                        data: request,
                        success: true
                    })];
            });
        }); },
        updateFormAPI: sendCommunication,
        formProps: {
            p: 2
        },
        onClose: function () { return onClose(); }
    });
}
